import { render, staticRenderFns } from "./TeamTrainers.vue?vue&type=template&id=174a32ee&"
import script from "./TeamTrainers.vue?vue&type=script&lang=js&"
export * from "./TeamTrainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports